<template>
    <div ref="editorWrapper" :style="{ width: '100%' }">
        <Editor ref="editor" class="tinymce-editor" :model-value="modelValue"
            @update:modelValue="$emit('update:modelValue', $event)" :api-key="tinyMceApiKey" :init="configTinyMce()"
            @change="onChange">
            <template #toolbar>
                <span class="ql-formats">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                </span>
                <span class="ql-formats">
                    <select class="ql-header">
                        <option selected></option>
                        <option value="1"></option>
                        <option value="2"></option>
                        <option value="3"></option>
                        <option value="4"></option>
                        <option value="5"></option>
                        <option value="6"></option>
                    </select>
                    <button class="ql-list" value="ordered" />
                    <button class="ql-list" value="bullet" />
                </span>
                <span class="ql-formats">
                    <select class="ql-align">
                        <option selected></option>
                        <option value="center"></option>
                        <option value="right"></option>
                        <option value="justify"></option>
                    </select>
                </span>
                <span class="ql-formats">
                    <button class="ql-blockquote"></button>
                    <button class="ql-link"></button>
                    <button class="ql-image"></button>
                    <button class="ql-video"></button>
                </span>
                <span class="ql-formats">
                    <button class="ql-clean"></button>
                </span>
            </template>
        </Editor>
    </div>
</template>

<script>

import Editor from "@tinymce/tinymce-vue";
import { getTinyMceConfig } from "../../config/tinymce.config";
import config from "../../config";

export default {
    name: "TinyMceEditor",
    components: { Editor },
    props: {
        modelValue: { type: String, default: "" },
        onChange: Function,
        translateCustomData: Object,
        translateToCallback: Function,
        height: Number
    },
    emits: ["update:modelValue"],
    data() {
        return {
            configTinyMce: () => getTinyMceConfig(this.translateToCallback ? this.translateTo : null, this.translateCustomData, 300, false),
        };
    },
    watch: {
        modelValue(newVal) {
            if (newVal !== this.localValue) this.localValue = newVal;
        },
    },

    computed: {
        tinyMceApiKey() {
            return config.tinyMceApiKey
        },
        editorHeight() {
            return this.height || 500
        },
    },
    methods: {
        onChange(event) {
            if (this.onChange) this.onChange(event);
        },
        translateTo(customData) {
            if (this.translateToCallback) {
                this.translateToCallback(customData, this.modelValue)
            }
        }
    },
};
</script>

<style scoped>
.tinymce-editor {
    width: 100%;
    height: 320px;
}
</style>